var React = require('react');

function GridViewInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 3h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm11 0h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM4 14h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1zm11 0h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1z","stroke":"currentColor","strokeWidth":"2","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

GridViewInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = GridViewInline;

GridViewInline.default = GridViewInline;
